import React, { Component } from 'react';
import { Button, Icon } from 'antd';
import { language } from '../../../language';
import { utils } from '../../../services';
//图片广告提示
export class SearchBarTips extends Component<any> {
    addItem = () => {
        const { items, onChange } = this.props;
        onChange([...items, { uuid: utils.uuid() }]);
    };

    render() {
        return (
            <div className="entry-item item-create">
                <p>
                    <Button type={'link'} onClick={this.addItem}>
                        <Icon type="plus" />
                        {language.getText('components.SearchBar.addSearchWord')}
                    </Button>
                </p>
                <p>{language.getText('components.SearchBar.searchTips')}</p>
            </div>
        );
    }
}
